import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useSiteSettings = () => {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    axios.get(`${API}/site-settings`).then((r) => setSettings(r.data)).catch(() => setSettings(null));
  }, []);
  return settings;
};

export const useSubcategories = () => {
  const [subs, setSubs] = useState([]);
  useEffect(() => {
    axios.get(`${API}/subcategories`).then((r) => setSubs(r.data)).catch(() => setSubs([]));
  }, []);
  return subs;
};

export const useUGC = () => {
  const [ugc, setUgc] = useState([]);
  useEffect(() => {
    axios.get(`${API}/ugc`).then((r) => setUgc(r.data)).catch(() => setUgc([]));
  }, []);
  return ugc;
};

export const useSpinPrizes = () => {
  const [prizes, setPrizes] = useState([]);
  useEffect(() => {
    axios.get(`${API}/spin/prizes`).then((r) => setPrizes(r.data)).catch(() => setPrizes([]));
  }, []);
  return prizes;
};
